<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getDeviceList"
      clickable
      ref="deviceList"
      @click:row="getDetails($event.item)"
      title-text="控制设备列表"
    >
      <template slot="row-action" slot-scope="{ item }">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <template v-if="showPintuBtn">
            <v-tooltip left>
              <v-btn @click="setPintuDialog(item)" slot="activator" icon class="ma-0">
                <v-icon small>$vuetify.icons.lock</v-icon>
              </v-btn>
              <span>抬杆落杆</span>
            </v-tooltip>
          </template>
          <template v-if="showDeleteBtn">
            <v-tooltip left>
              <v-btn @click="deleteDeviceConfirm(item)" slot="activator" icon class="ma-0">
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除删除控制器</span>
            </v-tooltip>
          </template>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn @click="addDevice" icon="$vuetify.icons.add"></l-fixed-btn>
    <v-dialog width="435" v-model="pintuDialog" persistent>
      <v-layout column>
        <v-card class="pa-3">
          <div v-show="waitingForRes">
            <v-layout justify-center class="ml-2 subheading">
              正在查询指令操作结果...
            </v-layout>
            <v-layout justify-center class="ml-2 subheading"
              >剩余查询次数:{{ leftTime }}次</v-layout
            >
          </div>
          <div v-show="!waitingForRes && successMsg !== ''">
            <v-layout justify-center>
              <v-icon color="primary">$vuetify.icons.success</v-icon>
            </v-layout>
            <v-layout justify-center>
              <p style="font-size: 20px">指令操作成功</p>
            </v-layout>
          </div>
          <div v-show="!waitingForRes && successMsg === ''">
            <v-layout justify-center> <h2>控制器远程操作</h2></v-layout>
            <!-- <v-select
              label="选择操作卡口"
              :items="curData.subDevices"
              v-model="curSubdevice"
              item-text="name"
              item-value="sn"
            ></v-select> -->
            <v-radio-group v-model="curSubdevice" column label="选择操作卡口">
              <v-radio
                :label="item.name"
                :value="item.sn"
                v-for="item in curData.subDevices"
                :key="item.sn"
              ></v-radio>
            </v-radio-group>
            <v-radio-group v-model="curOperation" column label="选择执行操作">
              <v-radio
                :label="item.text"
                :value="item.value"
                v-for="item in items"
                :key="item.sn"
              ></v-radio>
            </v-radio-group>
            <div
              class="sliding-pictures"
              style="width: 400px"
              v-show="needValidate"
            >
              <div class="vimg">
                <canvas id="sliderBlock" width="=400" height="300"></canvas>
                <canvas id="codeImg" width="400" height="300"></canvas>
              </div>
              <div class="slider">
                <div class="track" :class="{ pintuTrue: puzzle }">
                  {{ tips }}
                </div>
                <div class="button" @mousedown.prevent="drag"></div>
              </div>
            </div>
            <v-layout row justify-center>
              <v-btn
                color="primary"
                @click="setLockValidate"
                :disabled="disabledFlag"
                v-show="showConfirm"
                >确定</v-btn
              >
              <v-btn color="error" @click="initDialog">取消</v-btn>
            </v-layout>
          </div>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import { time } from "../../../ladmin/utils/time";
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
import {PERMISSION} from '@/consts/userAdmin'
export default {
  name: "deviceList",
  components: { LDataTable },
  data() {
    return {
      waitingForRes: false,
      timer: null,
      leftTime: 5,
      lastLeftTime: 4,
      disabledFlag: false,
      tips: "拖动左边滑块完成上方拼图",
      pintuDialog: false,
      needValidate: false,
      showConfirm: true,
      successMsg: "",
      //滑块x轴数据
      blockData: {},
      //拼图是否正确
      puzzle: false,
      curData: { subDevices: [] },
      curSubdevice: "",
      curOperation: "DEVICESRV_CTRLLIFT",
      items: [
        { text: "抬杆", value: "DEVICESRV_CTRLLIFT" },
        { text: "落杆", value: "DEVICESRV_CTRLLEVER" },
      ]
    };
  },
  computed: {
    showPintuBtn () {
      return this.hasPermission(PERMISSION.PARK.CONTROLLER.OPERATION)
    },
    showDeleteBtn () {
      return this.hasPermission(PERMISSION.PARK.CONTROLLER.DELETE) &&
        this.hasPermission('park:iotController:admin')
    },
    header () {
      let width = 20
      if (this.showDeleteBtn) {
        width += 40
      }
      if (this.showPintuBtn) {
        width += 40
      }
      if (width < 60) {
        width = 0
      }
      return [
        { text: "设备名称", value: "name", sortable: false, align: "left" },
        {
          text: "创建时间",
          value: "creationTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
        {
          text: "设备登录时间",
          value: "signInTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
        {
          text: "上次心跳时间",
          value: "lastHeartBeatTime",
          sortable: true,
          align: "left",
          f: (v) => time.stringify(v),
        },
        {
          text: "设备状态",
          value: "status",
          sortable: false,
          align: "left",
          f: (v) => (v === "1" ? "在线" : "离线"),
        },
        { text: "版本号", value: "version", sortable: false, align: "left" },
        {
          text: "",
          value: "",
          sortable: false,
          align: "left",
          width: width
        },
      ]
    }
  },
  methods: {
    initDialog() {
      this.pintuDialog = false;
      this.needValidate = false;
      this.puzzle = false;
      this.canvasInit();
    },
    hasPermission(permission) {
      return this.$store.getters['login/hasPermissionOf'](permission)
      // let arr = permissions.split(":");
      // let per = this.$store.state.login.permission;
      // for (let i = 0; i < arr.length; i++) {
      //   if (per[arr[i]]) {
      //     per = per[arr[i]];
      //   } else {
      //     return false;
      //   }
      // }
      // return true;
    },
    setLockValidate() {
      // console.log(this.curData, 55);
      this.disabledFlag = true;
      this.needValidate = true;
      this.showConfirm = false;
    },
    //判断指令操作是否成功
    isSuccess(res) {
      if (res.status !== 200) {
        return false;
      }
      let data = (res.data.data.content && res.data.data.content[0]) || null;
      if (data) {
        if (!data.resData) {
          return false;
        }
        data = JSON.parse(data.resData);
        console.log(44, data);
        if (data.status === 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    //停止获取操作指令结果
    stopGetRes() {
      this.disabledFlag = false;
      clearInterval(this.timer);
      this.timer = null;
      this.leftTime = 5;
      this.lastLeftTime = 4;
      this.waitingForRes = false;
    },
    //开始获取操作指令结果
    startGetRes(queryId) {
      let _this = this;
      this.timer = setInterval(async () => {
        let res = await this.$store.dispatch(
          "iot/getControllerLockRes",
          queryId
        );
        // console.log(res);
        let flag = _this.isSuccess(res);
        if (flag) {
          _this.stopGetRes();
          _this.successMsg = "指令操作成功";
          let __this = _this;
          setTimeout(() => {
            __this.pintuDialog = false;
          }, 1500);
        } else {
          _this.leftTime = _this.lastLeftTime;
          _this.lastLeftTime = _this.leftTime - 1;
        }
      }, 1000);
    },
    async setControllerLock() {
      let params = {
        subDeviceId: this.curSubdevice,
        method: this.curOperation,
        ctrlId: this.curData.sn,
      };
      let res = await this.$store.dispatch("iot/setControllerLock", params);
      if (res.data.status === 200) {
        this.$L.alert("success", { message: "指令下发成功" });
        this.waitingForRes = true;
        this.startGetRes(res.data.data);
      } else {
        this.puzzle = false;
        this.disabledFlag = false;
        this.showConfirm = true;
        this.canvasInit();
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    setPintuDialog(item) {
      this.pintuDialog = true;
      // console.log(item);
      this.curData = item;
    },
    //拼图验证码初始化
    canvasInit() {
      //console.log("刷新");
      //生成指定区间的随机数
      const random = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min);
      };
      let x = random(100, 200);
      let y = random(100, 200);
      let w = 40;
      let r = 9;
      let PI = Math.PI;
      this.blockData = { x, y, w, r };
      this.puzzle = false;
      this.draw(this.blockData);
    },
    drag(e) {
      let dom = e.target; //dom元素
      let slider = document.getElementById("sliderBlock"); //滑块dom
      const downCoordinate = { x: e.x, y: e.y };

      //正确的滑块数据
      let checkx = this.blockData.x + 2;
      //x轴数据
      let x = 0;
      const move = (moveEV) => {
        x = moveEV.x - downCoordinate.x;
        //y = moveEV.y - downCoordinate.y;
        if (x >= 400 || x <= 0) return false;
        dom.style.left = x + "px";
        //dom.style.top = y + "px";
        slider.style.left = x + "px";
      };

      const up = () => {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", up);
        dom.style.left = 0;
        slider.style.left = 16 + "px";
        // console.log(x, checkx);
        let max = checkx + 15;
        let min = checkx - 15;
        //允许正负误差1
        if ((max >= x && x >= min) || x === checkx) {
          //console.log("滑动解锁成功");
          this.puzzle = true;
          this.tips = "验证成功";
          setTimeout(() => {
            this.tips = "拖动左边滑块完成上方拼图";
            this.needValidate = false;
            this.setControllerLock();
          }, 500);
        } else {
          //console.log("拼图位置不正确");
          this.tips = "验证失败，请重试";
          this.canvasInit();
        }
      };

      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);
    },
    draw(blockData) {
      const { x, y, w, r } = blockData;
      let mainDom = document.getElementById("codeImg");
      let bg_ctx = mainDom.getContext("2d");
      let blockDom = document.getElementById("sliderBlock");
      let block_ctx = blockDom.getContext("2d");
      let imgsrc = require("../../../assets/拼图测试.jpeg");
      let img = document.createElement("img");
      // img.style.objectFit = "scale-down";
      blockDom.width = 400;
      bg_ctx.clearRect(0, 0, 400, 300);
      block_ctx.clearRect(0, 0, 400, 300);
      img.src = imgsrc;
      img.onload = function () {
        bg_ctx.drawImage(img, 0, 0, 400, 300);
        block_ctx.drawImage(img, 0, 0, 400, 300);
        var blockWidth = w + r * 2;
        var _y = y - r * 2 + 2; // 滑块实际的y坐标
        var _x = x - r * 2 + 2;
        console.log(blockWidth, 666);
        var ImageData = block_ctx.getImageData(x, _y, blockWidth, blockWidth);
        blockDom.width = blockWidth;
        block_ctx.putImageData(ImageData, 2, _y);
      };
      this.drawBlock(bg_ctx, blockData, "fill");
      this.drawBlock(block_ctx, blockData, "clip");
    },
    //绘制拼图
    drawBlock(ctx, blockData, type) {
      const { x, y, w, r } = blockData;
      const PI = Math.PI;
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x + w / 2, y);
      ctx.arc(x + w / 2, y - r + 2, r, 0, 2 * PI); //
      ctx.lineTo(x + w / 2, y);
      ctx.lineTo(x + w, y);
      ctx.lineTo(x + w, y + w / 2);
      ctx.arc(x + w + r - 2, y + w / 2, r, 0, 2 * PI); //
      ctx.lineTo(x + w, y + w / 2);
      ctx.lineTo(x + w, y + w);
      ctx.lineTo(x, y + w);
      ctx.lineTo(x, y);
      ctx.fillStyle = "#fff";
      ctx[type]();
      ctx.beginPath();
      ctx.arc(x, y + w / 2, r, 1.5 * PI, 0.5 * PI); // 只需要画正方形内的半圆就行，方便背景图片的裁剪
      ctx.globalCompositeOperation = "xor";
      ctx.fill();
    },
    async getDeviceList({ pagination, sortStack, filterItems, search }) {
      let { items, amount } = await this.$store.dispatch("iot/getDeviceList", {
        pagination,
        search: { key: "name", value: search },
      });
      let arr = [];
      for (let i = 0; i < items.length; i++) {
        let obj = items[i];
        obj.lastHeartBeatTime = obj.msgRecord && obj.msgRecord.creationTime;
        let extend = JSON.parse(items[i].extend);
        if (extend.signInTime === undefined) {
          obj.signInTime = "N/A";
        } else {
          obj.signInTime = extend.signInTime;
        }
        arr.push(obj);
      }
      return { items: arr, amount: amount };
    },
    addDevice() {
      this.$router.push({ name: "newIotDevice" });
    },
    async deleteDeviceConfirm(item) {
      let { res, close } = await this.$L.confirm({
        title: "确认删除该控制器？",
        text: "控制器名称:" + item.name,
      });
      if (res) {
        try {
          await this.deleteDevice(item);
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async deleteDevice(item) {
      let ids = [];
      ids.push(item.id);
      let params = {
        ids: ids,
      };
      let res = await this.$store.dispatch("iot/deleteDevice", params);
      if (res.data.status + "" === "200") {
        this.$L.alert("success", { message: "删除成功" });
        this.$refs.deviceList.refresh();
      } else {
        this.$L.alert("error", { message: "删除失败，原因：" + res.data.msg });
      }
    },
    getDetails(item) {
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        if (this.hasPermission(PERMISSION.PARK.CONTROLLER.DETAIL)) {
          this.$router.push({ name: "deviceDetailBox", query: { id: item.id } });
        } else {
          this.$L.alert("error", { message: "暂无查看详情权限" });
        }
      }
    },
  },
  watch: {
    pintuDialog(e) {
      if (e === true) {
        this.canvasInit();
        this.successMsg = "";
      } else {
        this.disabledFlag = false;
        this.showConfirm = true;
      }
    },
    leftTime(e) {
      if (e < 0) {
        this.stopGetRes();
        this.canvasInit();
        this.$L.alert("error", {
          message: "未查询到指令操作结果，请重新下发指令",
        });
      }
    },
  },
};
</script>

<style scoped>
.slidingPictures {
  padding: 0;
  width: 400px;
  border-radius: 2px;
}
.vimg {
  width: 400px;
  height: 300px;
}
/* #codeImg,
#sliderBlock {
  padding: 7px 7px 0 7px;
  width: inherit;
  height: inherit;
} */

#sliderBlock {
  position: absolute;
  z-index: 100;
}

.slider {
  width: 400px;
  height: 65px;
  border-bottom: #c7c9d0 1px solid;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.track {
  margin-left: 7px;
  width: 400px;
  height: 38px;
  background: rgba(28, 136, 188, 0.5);
  border-radius: 25px;
  font-size: 14px;
  line-height: 38px;
  padding-right: 15px;
  padding-left: 70px;
}
.pintuTrue {
  background: #67c23a;
  color: #ffffff;
}
.button {
  position: absolute;
  width: 50px;
  height: 50px;
  line-height: 48px;
  background: #ffffff;
  box-shadow: #b9bdc8 0 0 3px;
  border-radius: 50%;
  left: 7px;
  text-align: center;
  font-size: 28px;
  color: #3e5d8b;
}
.button:hover {
  color: #2181bd;
}
</style>
